// loadComponent comunica con la libreria npm che abbiamo installato, qui stiamo importando McElement che in sostanza estende HTMLElement (lo trovi nella sezione test)
// tutti i componenti che ti servono vanno chiamati così, con /components/nome-componente.js se sono su npm, li trovi tutti nella tab Componenti in sezione test
await loadComponent('./components/mc-element.js', false);
// queste sono le uniche librerie che hanno "res" invece che "components", le ho messe qua solo per farti vedere come si importano
await loadComponent('./res/mc-utils.js', false); // la trovi documentata sulla tab McUtils nella sezione test
await loadComponent('./res/mc-events.js', false); // la trovi documentata sulla tab Eventi nella sezione test
await loadComponent('./res/mc-shopify.js', false); // la trovi documentata sulla tab McShopify nella sezione test



// ExampleComponent è un componente custom che estende McElement, McElement estende HTMLElement e fornisce funzionalità aggiuntive per la creazione di componenti web personalizzati.
class ProductInfo extends McElement {

    connectedCallback() {
        this.cmpLoad();
      window.addEventListener('variant:select', this.update.bind(this));
    }

    update = (e) => {
      const url = e.detail.url;
      if(!url){
        console.error('ProductInfo: URL not found');
        return;
      }

      console.log('ProductInfo: URL found', url);
      this.reload({ url: url });
      window.history.replaceState({}, '', url);
    }

    cmpLoad = () => {
        const form = this.querySelector('form');
        //const form = document.getElementById('product_form_15241867526409');
        const addBtn = this.querySelector('[data-add-to-cart]');

        //alert(form);


        // AGGIUNTA AL CARRELLO DESKTOP
        if (addBtn && form) {
            addBtn.addEventListener('click', () => {
                if (typeof McShopify?.addToCart === 'function') {
                    McShopify.addToCart({form: form});
                }
            });
        }

        //per titolo prendi il titolo del prodotto
        //per url prendi la pagina corrente

        const shareData = {
            title: document.title, // prendi il titolo della pagina corrente
            text: "Condividi questo prodotto!", // testo da condividere
            url: window.location.href // prendi l'url della pagina corrente
        };

        const btn = document.querySelector(".share-placeholder");
        //const resultPara = document.querySelector(".result");

        // Share must be triggered by "user activation"
        btn.addEventListener("click", async () => {
            try {
                await navigator.share(shareData);
                //resultPara.textContent = "MDN shared successfully";
            } catch (err) {
                //resultPara.textContent = `Error: ${err}`;
            }
        });



    }
}

// il nome del componente deve essere in kebab-case, e deve essere unico, altrimenti non funzionerà
if (!customElements.get('product-info')) {
    // registriamo il componente, se non è già stato registrato
    customElements.define('product-info', ProductInfo);
}
window.ProductInfo = ProductInfo; // rendiamo il componente accessibile globalmente